/**
 * pagination abstraction
*/
const Facade_Pagination={
    /**
     * get the offset
     * the start number of an array slice
     * 
     * @param {number} param_items_per_page
     * @param {number} param_page
    */
    get_offset:function(param_items_per_page,param_page)
    {
        return (param_items_per_page*(param_page-1));
    },
    /**
     * get the limit
     * the end number of an array slice
     * 
     * @param {number} param_items_per_page
     * @param {number} param_page
    */
    get_limit:function(param_items_per_page,param_page)
    {
        return ((param_items_per_page*param_page)-1);
    }
}

/**
 * mobile detection abstraction
*/
const Facade_Mobile_Detect={
    /**
     * check if is any mobile size
    */
    check:function()
    {
        if(Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1)
        {
            return true;
        }
        else
        {
            return false;
        }
    }
}

//==================================
//EXPORTS
//==================================
export {Facade_Pagination,Facade_Mobile_Detect};